import { ResizePanelProps } from "./ResizePanelProps";
import { resolveSupportingPanelMinSize } from "./resolveSupportingPanelMinSize";
import { resolveSupportingPaneDefaultSize } from "./resolveSupportingPaneDefaultSize";
import { useMemo } from "react";
import { resolveSupportingPanelMaxSize } from "./resolveSupportingPanelMaxSize";

export type UseResolveSupportingPanelSizesReturnValue = {
  supportingPanelDefaultSize: number | undefined;
  supportingPanelMaxSize: number | undefined;
  supportingPanelMinSize: number | undefined;
};
export const useResolveSupportingPanelSizes = (args: {
  direction: "vertical" | "horizontal";
  supportingPaneOpen: boolean;
  height: number | undefined;
  width: number | undefined;
  resizePanelProps: ResizePanelProps | undefined;
}): UseResolveSupportingPanelSizesReturnValue => {
  const minSize = resolveSupportingPanelMinSize({
    direction: args.direction,
    width: args.width,
    height: args.height,
    minWidth: args.resizePanelProps?.minWidth,
    minHeight: args.resizePanelProps?.minHeight,
  });

  const maxSize = resolveSupportingPanelMaxSize({
    direction: args.direction,
    width: args.width,
    height: args.height,
    maxWidth: args.resizePanelProps?.maxWidth,
    maxHeight: args.resizePanelProps?.maxHeight,
  });

  const defaultSize = resolveSupportingPaneDefaultSize({
    supportingPaneOpen: args.supportingPaneOpen,
    supportingPanelMinSize: minSize,
    supportingPanelMaxSize: maxSize,
  });

  return useMemo(() => {
    return {
      supportingPanelDefaultSize: defaultSize,
      supportingPanelMinSize: minSize,
      supportingPanelMaxSize: maxSize,
    };
  }, [defaultSize, maxSize, minSize]);
};
